import {
  setProductThumbEvents,
  setProductPageEvents,
  setPurchaseListEvents,
  setCheckoutEvents,
  setPurchaseEvent
} from './datalayer/mkx-events';
import { setUserData } from './datalayer/user-data.js';
import { DataLayerEvents } from './datalayer/data-layer-events.js';
import { DataLayerHandler } from './datalayer/data-layer-handler.js';

document.addEventListener('DOMContentLoaded', () => {
  try {
    DataLayerHandler.init();
    DataLayerEvents.init();
    setUserData();
    setProductThumbEvents();
    setProductPageEvents();
    setPurchaseListEvents();
    setCheckoutEvents();
    setPurchaseEvent();
  } catch (e) {
    // console.error(e);
  }
});